export default {
  hotGame: [
    {
      id: 2,
      gameImage: 'http://8828game.com/webImages/image/02/anli10.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame10.jpg',
      gameName: '钱袋子保卫战',
      gameType: '(金融知识宣传合作)',
      gameDesc: '合作品牌：中国人民银行',
      hotGameActive: ''
    },
    {
      id: 4,
      gameImage: 'http://8828game.com/webImages/image/02/anli09.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame09.png',
      gameName: '坦克3合1',
      gameType: '(肯德基品牌合作)',
      gameDesc: '合作品牌：百胜餐饮集团',
      hotGameActive: ''
    },
    {
      id: 3,
      gameImage: 'http://8828game.com/webImages/image/02/anli08.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode04.jpg',
      gameName: '《超级飞侠冲冲冲》',
      gameType: '(IP精品合作)',
      gameDesc: '合作品牌：奥飞娱乐',
      hotGameActive: ''
    },
    {
      id: 1,
      gameImage: 'http://8828game.com/webImages/image/02/anli07.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode01.jpg',
      gameName: '欢乐农场主',
      gameType: '(电商扶贫合作)',
      gameDesc: '合作品牌：腾讯公益',
      hotGameActive: ''
    }
  ],
  cooperationGame: [
    {
      id: 1,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai01.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode01.jpg',
      gameName: '《欢乐农场主》 电商扶贫合作',
      gameDesc: '《欢乐农场主》是国家财政部、腾讯微信、广州匠心游戏联手致力于帮助国家贫困县宣传和农产品销售的公益项目，通过游戏的形式展现也是希望用更加愉快温暖的方式，让更多的',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon01.jpg'
    },
    {
      id: 2,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai03.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode03.jpg',
      gameName: '《直通天际》 迪拜塔旅游商业合作',
      gameDesc: '人们对于高空、未知的探索总是欲望无穷，因此成就了迪拜塔（又名哈利法塔）和它相关的小游戏项目，游戏采用了迪拜塔的现代建筑风格用叠高楼的形式展现迪拜塔的高大雄伟。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon03.jpg'
    },
    {
      id: 3,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai02.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode02.jpg',
      gameName: '《萌鸡小队画画》 IP精品战略合作',
      gameDesc: '《萌鸡小队》动画有着70亿庞大的网络视频点击量，收罗了一群忠实的小粉丝；为做到寓教于乐的效果，特选IP+画画的游戏模式，自主创新角色舞蹈+音乐的玩法，大大增加了产品代入感，建立产品壁垒，让小朋友的天分更加自由的发挥',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon02.jpg'
    },
    {
      id: 4,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai04.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode04.jpg',
      gameName: '《超级飞侠冲冲冲》 IP精品战略合作',
      gameDesc: '《超级飞侠》是一部全网点击百亿，多角色市场反响火爆的儿童动画，宣传以帮助别人为主基调非常正能量，我们希望小朋友能够通过游戏加深对每个飞侠的角色认知，从而提高IP认知度，并帮助品牌进行一定的周边销售',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon04.jpg'
    }
  ],
  allGames: [
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon01.png',
      gameName: '豆腐消消消'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon02.jpg',
      gameName: '非常六合一'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon03.jpg',
      gameName: '宇宙大冒险'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon04.jpg',
      gameName: '最强切水果'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon05.png',
      gameName: '爆锤损友'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon06.png',
      gameName: '最强消数字'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon07.png',
      gameName: '答题大乱斗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon08.png',
      gameName: '最强弹力球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon09.jpg',
      gameName: '划线球球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon10.png',
      gameName: '最强预测'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon11.png',
      gameName: '最强球爱'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon12.jpg',
      gameName: '最强吃鸡王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon13.jpg',
      gameName: '豆腐消消消'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon14.jpg',
      gameName: '最强嘴炮王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon15.jpg',
      gameName: '脑力大火拼'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon16.png',
      gameName: '最强菊王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon17.png',
      gameName: '去吧皮卡叔'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon18.png',
      gameName: '盗猫笔记'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon19.png',
      gameName: '一起切水果'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon20.png',
      gameName: '猫咪大乱斗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon21.png',
      gameName: '养猫达人'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon22.png',
      gameName: '全民飞车3D'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon23.png',
      gameName: '我要养条狗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon24.png',
      gameName: '怪兽连连线'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon25.png',
      gameName: '进击吧足球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon26.png',
      gameName: '一起来切菜'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon27.jpg',
      gameName: '水果大师'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon28.jpg',
      gameName: '劲爆足球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon29.jpg',
      gameName: '王者俄罗斯方块'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon30.jpg',
      gameName: '宝宝开餐厅'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon31.jpg',
      gameName: '飞机大战3D'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon32.png',
      gameName: '疯狂怪兽车'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon33.png',
      gameName: '数字连连消'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon34.png',
      gameName: '超级飞侠'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon35.jpg',
      gameName: '萌鸡小队画画'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon36.png',
      gameName: '一起切糖果'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon37.jpg',
      gameName: '欢乐农场主'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon38.jpg',
      gameName: '直通天际'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon39.png',
      gameName: '本宫能活100集'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon40.png',
      gameName: '步战三国'
    }
  ]
}
